module.exports = __webpack_public_path__ + "static/media/Willpower.13173039.svg";